import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { Radio, Users, Clock, Sparkles } from 'lucide-react';
import WhatsAppStyleNode from './WhatsAppStyleNode';
import { BroadcastNodeData } from '../../types/nodes';

const broadcastIcons = {
  list: <Users />,
  segment: <Radio />,
  scheduled: <Clock />,
  dynamic: <Sparkles />
};

const broadcastLabels = {
  list: 'Broadcast Lista',
  segment: 'Broadcast Segmento',
  scheduled: 'Broadcast Programmato',
  dynamic: 'Broadcast Dinamico'
};

const BroadcastNode: React.FC<NodeProps<BroadcastNodeData>> = memo(({ selected, data }) => {
  const icon = broadcastIcons[data.broadcastType] || <Radio />;
  const label = broadcastLabels[data.broadcastType] || 'Broadcast';
  
  const getPreview = () => {
    switch (data.broadcastType) {
      case 'list':
        return `${data.config.recipientList?.length || 0} destinatari`;
      case 'segment':
        return 'Segmento personalizzato';
      case 'scheduled':
        return data.config.scheduleTime || 'Non programmato';
      case 'dynamic':
        return data.config.dynamicContent ? 'Contenuto dinamico' : 'Contenuto statico';
      default:
        return null;
    }
  };

  return (
    <WhatsAppStyleNode
      selected={selected}
      icon={icon}
      label={label}
      preview={getPreview()}
      color="from-lime-500 to-green-600"
      handles={{
        target: true,
        source: true,
      }}
    />
  );
});

BroadcastNode.displayName = 'BroadcastNode';

export default BroadcastNode;
